import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { UserFindParams, User } from '../models/user';
import { ApiResponse, PaginationApiResponse } from '../models/api-response';
import { ConfigService } from './config.service';
import { UrlHelper } from '../helpers/url.helper';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(ConfigService);

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  private get baseUrl(): string {
    return `${this.config.config.urlApi}users`;
  }

  public getUsers(
    page: number = 1,
    pageSize: number = 10,
    pagination: boolean = true,
    filters?: UserFindParams,
  ): Observable<PaginationApiResponse<User[]>> {
    const params: string = pagination ? `?${UrlHelper.objectToUrlParams({ pagination, page, pageSize, ...filters })}` : '';

    return this.http.get<PaginationApiResponse<User[]>>(`${this.baseUrl}${params}`);
  }

  public getUser(id: number | string): Observable<User> {
    return this.http.get<ApiResponse<User>>(`${this.baseUrl}/${id}`).pipe(map((response: ApiResponse<User>) => response.data));
  }

  public updateUser(payload: User): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>(`${this.baseUrl}/${payload.id}`, payload, this.httpOptions);
  }

  public createUser(payload: User): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.baseUrl}`, payload, this.httpOptions);
  }

  public deleteUser(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  public getUseProfile(): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}/profile`).pipe(map((response: any) => response.data));
  }

  public getUserKeycloak(id: string): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}/uuid/${id}`).pipe(map((response: any) => response.data));
  }

  public disabledUser(payload: User): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.baseUrl}/${payload.id}/disable`, {}, this.httpOptions);
  }
}
